"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromSSO = void 0;
const credential_provider_sso_1 = require("@aws-sdk/credential-provider-sso");
const fromSSO = (init = {}) => {
    return (0, credential_provider_sso_1.fromSSO)({ ...init });
};
exports.fromSSO = fromSSO;
